import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MultiPickFromList from "../multiPickFromList/multiPickFromList";
import Modal from "react-modal";
import "./floatingForm.scss";

function CreateFloatingGroup(props) {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    document.getElementById("globalOverlay")?.addEventListener("click", () => {
      setModalOpen(false);
      //TODO: the same code executed in dashboardConfigurator
      document.getElementById("globalOverlay")?.classList.remove("active");
    });
  }, []);

  const toggleGlobalOverlay = () => {
    document.getElementById("globalOverlay")?.classList.toggle("active");
  };

  const onButtonClick = () => {
    setModalOpen(true);
    toggleGlobalOverlay();
  };

  const closeModal = () => {
    props.itemWasChecked(props.defaultCheckedItems)
    setModalOpen(false);
    toggleGlobalOverlay();
  };

  function getParent() {
    return document.querySelector(props.module);
  }

  const cName = !props.overrideButton ? " buttonContent" : "";

  return (
    <span className="floating-form">
      <button
        className={"floating-form-add-button" + cName}
        onClick={onButtonClick}
        style={!props.overrideButton ? props.buttonStyle : null}
      >
        {props.overrideButton ? props.buttonContent : <span className="plus">+</span>}
      </button>
      <Modal
        ariaHideApp={false}
        parentSelector={getParent}
        className="floating-form-modal"
        overlayClassName="floating-form-overlay"
        isOpen={modalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick
        style={{
          content: {
            width: props.modalWidth,
            height: props.modalHeight
          }
        }}
      >
        <div className="floating-form-content" data-testid="floatingGroupForm">
          <h3>{props.title}</h3>
          <MultiPickFromList
            hasPreLabel={props.hasPreLabel}
            checkList={props.checkList}
            defaultCheckedItems={props.defaultCheckedItems}
            selectHeight={props.selectHeight}
            modalWidth={props.modalWidth}
            itemWasChecked={props.itemWasChecked}
            maxDonuts={props.maxDonuts}
            maxChecked={props.maxChecked}
          />
          <div className="floating-form-content-btn">
            <button
              type="submit"
              onClick={() => {
                props.onSubmit({ checkedGroups: {}, groupName: "" });
                closeModal();
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>
    </span>
  );
}

CreateFloatingGroup.propTypes = {
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  title: PropTypes.string,
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      label: PropTypes.any
    })
  ),
  defaultCheckedItems: PropTypes.object,
  onSubmit: PropTypes.func,
  buttonStyle: PropTypes.object,
  selectHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  modalHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  module: PropTypes.string,
  itemWasChecked: PropTypes.func,
  maxDonuts: PropTypes.number,
  maxChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  overrideButton: PropTypes.bool,
  buttonContent: PropTypes.any,
  hasPreLabel: PropTypes.bool
};

export default CreateFloatingGroup;
